module.exports = __webpack_public_path__ + "static/media/Roboticon02@2x.2c7febaa.png";